import { render, staticRenderFns } from "./categorySubInfo.vue?vue&type=template&id=95867412&scoped=true&"
import script from "./categorySubInfo.vue?vue&type=script&lang=js&"
export * from "./categorySubInfo.vue?vue&type=script&lang=js&"
import style0 from "./categorySubInfo.vue?vue&type=style&index=0&id=95867412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95867412",
  null
  
)

export default component.exports